import { FieldErrors } from './FieldErrors';

import { useFieldContext } from '.';

interface Props {
  label: string;
  required?: boolean;
}

export function MonsterCheckbox({ label, required = false }: Props) {
  const field = useFieldContext<boolean>();

  return (
    <div className='relative flex items-start'>
      <div className='flex h-6 items-center'>
        <input
          required={required}
          onChange={(e) => field.handleChange(e.target.checked)}
          checked={field.state.value}
          id={field.name}
          name={field.name}
          type='checkbox'
          onBlur={field.handleBlur}
          className='focus:ring-dark-purple h-4 w-4 cursor-pointer rounded-sm border-gray-300 text-indigo-600'
        />
      </div>
      <div className='ml-3 leading-6'>
        <label htmlFor={field.name} className='font-medium'>
          {label}
        </label>
      </div>
      <FieldErrors meta={field.state.meta} />
    </div>
  );
}
